'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormatter, useTranslations } from 'next-intl';
import { DataTable } from '@/components/ui/data-table';
import type { MarketBoosterLeaderboardEntry } from './types';
interface MarketBoosterRowCellsProps {
  entry: MarketBoosterLeaderboardEntry;
  isUser: boolean;
}
export function MarketBoosterRowCells(t0) {
  const $ = _c(25);
  const {
    entry,
    isUser
  } = t0;
  const formatter = useFormatter();
  const t = useTranslations("market.boosters");
  let relativeLastBoost = "\u2014";
  if (entry.lastBoostAt !== null) {
    if ($[0] !== entry.lastBoostAt || $[1] !== formatter) {
      const parsed = new Date(entry.lastBoostAt);
      if (!Number.isNaN(parsed.getTime())) {
        relativeLastBoost = formatter.relativeTime(parsed, new Date());
      }
      $[0] = entry.lastBoostAt;
      $[1] = formatter;
      $[2] = relativeLastBoost;
    } else {
      relativeLastBoost = $[2];
    }
  }
  let t1;
  if ($[3] !== entry.rank || $[4] !== isUser) {
    t1 = <DataTable.RankCell value={entry.rank} isCurrentUser={isUser} />;
    $[3] = entry.rank;
    $[4] = isUser;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== entry.booster || $[7] !== isUser) {
    t2 = <DataTable.IdentityCell user={entry.booster} showYouBadge={isUser} />;
    $[6] = entry.booster;
    $[7] = isUser;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== relativeLastBoost) {
    t3 = <DataTable.TextCell align="right" hideOnMobile={true}>{relativeLastBoost}</DataTable.TextCell>;
    $[9] = relativeLastBoost;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = Number(entry.totalAmount);
  let t5;
  if ($[11] !== entry.numBoosts || $[12] !== t) {
    t5 = t("boosts_count", {
      count: entry.numBoosts
    });
    $[11] = entry.numBoosts;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <DataTable.NumericCell value={t4} format="usd" mobileSecondary={t5} />;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== entry.numBoosts) {
    t7 = <DataTable.NumericCell value={entry.numBoosts} format="int" hideOnMobile={true} />;
    $[17] = entry.numBoosts;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t6 || $[23] !== t7) {
    t8 = <>{t1}{t2}{t3}{t6}{t7}</>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}